import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-279423ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "schedule__content-desktop-columns" }
const _hoisted_3 = { class: "schedule__table" }
const _hoisted_4 = ["rowspan"]
const _hoisted_5 = ["rowspan"]

import { Venues } from "@/components/schedule/useSchedule";
import ScheduleEventBox from "./ScheduleEventBox.vue";
const TIME_BLOCK = 10


export default /*#__PURE__*/_defineComponent({
  __name: 'DayBlock',
  props: {
    dayName: {},
    title: {},
    dayData: {}
  },
  emits: ["set-modal-content"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const hoursToMinutes = (time: string) => {
  const hours = parseInt(time.substr(0, 2));
  const minutes = parseInt(time.substr(3, 2));
  return hours * 60 + minutes;
};

const getCellStyle = (rowData: any, venue: any) => {
  const isDisplayContent = rowData.paralelniPolis && !rowData.laFabrika && rowData.paralelniPolis.laFabrikaEventRowspanNum > 0;

  const changedPadding = rowData.isInTimeRange ? {padding: '30px 0', display: isDisplayContent ? 'contents' : 'table-cell'} : {padding: '0'}

  return venue ? {} : changedPadding
}

const prepareDataForTable = (dayObjectWithEvents?: any) => {
  let startTimeInMinutes = 0;
  let resultArray = [];

  const earliestEventTime = dayObjectWithEvents.reduce((min: any, p: any) => hoursToMinutes(p.start) < min ? hoursToMinutes(p.start) : min, 1440);

  const latestEventTime = dayObjectWithEvents.reduce((max: any, p: any) => (hoursToMinutes(p.start) + hoursToMinutes(p.duration)) > max ? (hoursToMinutes(p.start) + hoursToMinutes(p.duration)) : max, 0);

  let laFabrikaEventRowspanNum = 0

  do {
    const isInTimeRange = startTimeInMinutes > earliestEventTime && startTimeInMinutes < latestEventTime
    
    let laFabrikaEvent = dayObjectWithEvents.find((event: any) => {
      return (
        event.room === Venues.LA_FABRIKA &&
        hoursToMinutes(event.start) < startTimeInMinutes + (TIME_BLOCK - 1) &&
        hoursToMinutes(event.start) + (TIME_BLOCK - 1) > startTimeInMinutes
      );
    });

    let polisEvent = dayObjectWithEvents.find((event: any) => {
      return (
        event.room === Venues.PARALELNI_POLIS &&
        hoursToMinutes(event.start) < startTimeInMinutes + (TIME_BLOCK - 1) &&
        hoursToMinutes(event.start) + (TIME_BLOCK - 1) > startTimeInMinutes
      );
    });

    const isPolisEventAlreadyInArray: any = resultArray.some((event) => {
      if (event.paralelniPolis && event.paralelniPolis.event && polisEvent)
        return event.paralelniPolis.event.id === polisEvent.id;
    });
    if (isPolisEventAlreadyInArray) {
      polisEvent = undefined;
    }

    const isLaFabrikaAlreadyInArray: any = resultArray.some((event) => {
      if (event.laFabrika && event.laFabrika.event && laFabrikaEvent)
        return event.laFabrika.event.id === laFabrikaEvent.id;
    });

    laFabrikaEventRowspanNum = laFabrikaEvent ? Math.floor(hoursToMinutes(laFabrikaEvent.duration) / TIME_BLOCK) : laFabrikaEventRowspanNum - 1
    if (isLaFabrikaAlreadyInArray) {
      laFabrikaEvent = undefined;
    }

      resultArray.push({
        paralelniPolis:
          polisEvent && !isPolisEventAlreadyInArray
            ? {
                laFabrikaEventRowspanNum,
                event: polisEvent,
                duration: hoursToMinutes(polisEvent.duration),
                rowSpan: Math.floor(hoursToMinutes(polisEvent.duration) / TIME_BLOCK),
              }
            : undefined,
        laFabrika:
          laFabrikaEvent && !isLaFabrikaAlreadyInArray
            ? {
                event: laFabrikaEvent,
                duration: hoursToMinutes(laFabrikaEvent.duration),
                rowSpan: Math.floor(
                  hoursToMinutes(laFabrikaEvent.duration) / TIME_BLOCK
                ),
              }
            : undefined,
        startTime: startTimeInMinutes,
        isInTimeRange
      });

    startTimeInMinutes += TIME_BLOCK;
  } while (startTimeInMinutes < hoursToMinutes("23:59"));

  
  return resultArray;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: `${_ctx.dayName}-desktop`,
      class: "schedule__day-title"
    }, _toDisplayString(_ctx.title), 9, _hoisted_1),
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prepareDataForTable(_ctx.dayData), (rowData) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: rowData.startTime
            }, [
              _createElementVNode("td", {
                style: _normalizeStyle(getCellStyle(rowData, rowData.laFabrika)),
                class: "schedule__table-cell",
                rowspan: 
              rowData.laFabrika && rowData.laFabrika.rowSpan > 1 ? rowData.laFabrika.rowSpan : 1
            
              }, [
                (rowData.laFabrika)
                  ? (_openBlock(), _createBlock(ScheduleEventBox, {
                      key: 0,
                      onClick: ($event: any) => (
                emit(
                  'set-modal-content',
                  rowData.laFabrika ? rowData.laFabrika.event : ''
                )
              ),
                      event: rowData.laFabrika.event,
                      rowspan: rowData.laFabrika.rowSpan
                    }, null, 8, ["onClick", "event", "rowspan"]))
                  : _createCommentVNode("", true)
              ], 12, _hoisted_4),
              _createElementVNode("td", {
                style: _normalizeStyle(getCellStyle(rowData, rowData.paralelniPolis)),
                class: "schedule__table-cell",
                rowspan: 
              rowData.paralelniPolis && rowData.paralelniPolis.rowSpan > 1
                ? rowData.paralelniPolis.rowSpan
                : 1
            
              }, [
                (rowData.paralelniPolis)
                  ? (_openBlock(), _createBlock(ScheduleEventBox, {
                      key: 0,
                      onClick: ($event: any) => (
                emit(
                  'set-modal-content',
                  rowData.paralelniPolis ? rowData.paralelniPolis.event : ''
                )
              ),
                      event: rowData.paralelniPolis.event,
                      rowspan: rowData.paralelniPolis.rowSpan
                    }, null, 8, ["onClick", "event", "rowspan"]))
                  : _createCommentVNode("", true)
              ], 12, _hoisted_5)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})